import { Component, OnInit } from '@angular/core';
// import { TranslateService } from '@ngx-translate/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {  AuthService } from '../../../services/auth.service'
import { DomSanitizer, Title } from '@angular/platform-browser';
import { UntypedFormControl, FormGroupDirective, NgForm, Validators, UntypedFormGroup, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-forgot-pass',
  templateUrl: './forgot-pass.component.html',
  styleUrls: ['./../../home/home.component.css','./forgot-pass.component.css',  '../../../../../../node_modules/bootstrap3/dist/css/bootstrap.min.css'],
  animations: [
    trigger('ShowHide', [
      state('spinning', style({ opacity:1 })),
      state('stopped', style({ opacity: 0, display:'none' })),
      transition('spinning => stopped', [ animate('300ms') ]),
      transition('stopped => spinning', [ animate('300ms') ]),

    ]),
  ]
})
export class ForgotPassComponent implements OnInit {

  BannerURL:any;
  submitted = false;
  loaderspinning = false;
  forgotPwdForm: UntypedFormGroup;
  changedPassSuccess = true;
  PwdChangeMsg = '';
  SP_CODE_ARR = []

  IsOtpHide:boolean=false
  IsMainSubmitBtnShow:boolean=false
  IsOtpSubmitBtnShow:boolean=false


  constructor(
    // private translate: TranslateService,
    private authServObj: AuthService,
    private sanitizer: DomSanitizer,
    private datePipe:DatePipe) {
      localStorage.setItem("lang",'en')
      // translate.setDefaultLang(localStorage.getItem('lang'));
  }

  ngOnInit(): void {
    this.loaderspinning = true
    this.authServObj.getKamPersons().subscribe(getKamPersonsRes => {
      this.loaderspinning = false
      if(getKamPersonsRes && getKamPersonsRes.success && getKamPersonsRes.data){
        this.SP_CODE_ARR = getKamPersonsRes.data.map((item) => {
         return item.SPCode
        })
      }
    },error => {
      this.loaderspinning = false
      console.log(error);
    });

    this.authServObj.GetBannerDetail({PAGENAME:'HOME'}).subscribe(BannerDetailRes => {
      try{

        if(BannerDetailRes.success == true){
          if(BannerDetailRes.data[0].URL_TYPE.toUpperCase() == "MP4" || BannerDetailRes.data[0].URL_TYPE.toUpperCase() == "MOV"){
            this.BannerURL =  this.sanitizer.bypassSecurityTrustHtml('<video id="fst-video" loop autoplay muted style="width:100%;height:100%;"><source src='+BannerDetailRes.data[0].URL+' type="video/mp4"></video>') ;
          }else if(BannerDetailRes.data[0].URL_TYPE.toUpperCase() == "PNG" || BannerDetailRes.data[0].URL_TYPE.toUpperCase() == "JPG" || BannerDetailRes.data[0].URL_TYPE.toUpperCase() == "JPEG" ){
            this.BannerURL =  this.sanitizer.bypassSecurityTrustHtml('<img style="object-fit:cover;width:auto;max-width:100%;padding: 0;" src='+BannerDetailRes.data[0].URL+'>') ;
          }else{
            this.BannerURL =  this.sanitizer.bypassSecurityTrustHtml('<img style="object-fit:cover;width:auto;max-width:100%;padding: 0;" src="https://pcknstg.blob.core.windows.net/hdfile/webimg/login_event.png"/>') ;
          }
        }else{
          this.BannerURL =  this.sanitizer.bypassSecurityTrustHtml('<img style="object-fit:cover;width:auto;max-width:100%;padding: 0;" src="https://pcknstg.blob.core.windows.net/hdfile/webimg/login_event.png"/>') ;
        }
      }catch(err){
        this.BannerURL =  this.sanitizer.bypassSecurityTrustHtml('<img style="object-fit:cover;width:auto;max-width:100%;padding: 0;" src="https://pcknstg.blob.core.windows.net/hdfile/webimg/login_event.png"/>') ;
        console.log("err",err)
      }
    })

    this.forgotPwdForm = new UntypedFormGroup({
      'username': new UntypedFormControl(null, [Validators.required]),
      'emailid': new UntypedFormControl(null, [Validators.required,Validators.email]),
      'OTP' : new UntypedFormControl(null)
    });

  }

  onforgotPwdFormubmit() {
    if(this.forgotPwdForm.valid){
      if(this.SP_CODE_ARR.includes((this.forgotPwdForm.value.username.trim()).toUpperCase())){
        this.IsOtpHide = true
      }else{
        this.ForgotPwdSubmit()
        this.IsOtpHide = false
      }

    }else{
      this.loaderspinning = false;
      this.submitted = false;
    }
    // this.ForgotPwdSubmit()
  }


  ForgotPwdSubmit(){

    this.loaderspinning = true;
    this.submitted = true;
    if(this.forgotPwdForm.valid){
      if((this.forgotPwdForm.value.username.trim()).toUpperCase() == "ADMIN" || (this.forgotPwdForm.value.username.trim()).toUpperCase() == "NDADMIN"){
        this.loaderspinning = false;
        this.submitted = false;
        Swal.fire({
          icon: 'error',
          title: 'Your are not eligible to perform this operation.',
          showConfirmButton: false,
          timer: 2500
        })
        return
      }
      this.authServObj.onforgotPwdFormubmit({emailid:this.forgotPwdForm.value.emailid,username:this.forgotPwdForm.value.username.trim(),AppsCode:1}).subscribe(apiResp => {
        this.loaderspinning = false;
        if(apiResp.success){

          this.changedPassSuccess = true;

          Swal.fire({
            icon: 'success',
            title: 'Your password has been successully changed. The new password has been sent to your email id.',
            showConfirmButton: false,
            timer: 2500
          })

          //this.registrationForm.reset();
          setTimeout(function () {
            window.location.reload()
          },2000)
        }else{
          if(apiResp.msg){
            this.PwdChangeMsg = apiResp.msg;
          }
          this.changedPassSuccess = false;
        }

      });
    }else{
      this.loaderspinning = false;
      this.submitted = false;
    }

  }

  ForgotPasswordWithOTP(){
    if(this.forgotPwdForm.value.OTP == "" || this.forgotPwdForm.value.OTP == null){
      Swal.fire({
        icon: 'error',
        title: 'Enter OTP to perform this operation.',
        showConfirmButton: true,
        timer: 2500
      })
      return
    }
    this.loaderspinning = true
    this.authServObj.GetOTPWeb({"EMAILID":this.forgotPwdForm.value.emailid}).subscribe((ORes)=>{
      this.loaderspinning = false
      try {
        if(ORes.success == true){
          if(ORes.data == ""){
            Swal.fire({
              icon: 'error',
              title: 'OTP not found. Please Contact system administrator.',
              showConfirmButton: true,
              timer: 2500
            })
            return
          }else{
            const decrypt = (salt, encoded) => {
              const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
              const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
              return encoded
                .match(/.{1,2}/g)
                .map((hex) => parseInt(hex, 16))
                .map(applySaltToChar)
                .map((charCode) => String.fromCharCode(charCode))
                .join("");
            };

            const decrypted_string = decrypt("N@r0l@Gem$CRM", ORes.data);

            if(decrypted_string == this.forgotPwdForm.value.OTP){
              this.ForgotPwdSubmit()
            }else{
              Swal.fire({
                icon: 'error',
                title: 'OTP is not match.',
                showConfirmButton: true,
                timer: 2500
              })
            }
          }

        }else{
          Swal.fire({
            icon: 'error',
            title: 'Something went wrong. Please Contact system administrator.',
            showConfirmButton: true,
            timer: 2500
          })
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: error,
          showConfirmButton: true,
          timer: 2500
        })
      }
    })
  }
}
